import { render } from "./SasEventImage.vue?vue&type=template&id=18c011ce&scoped=true"
import script from "./SasEventImage.vue?vue&type=script&lang=js"
export * from "./SasEventImage.vue?vue&type=script&lang=js"

import "./SasEventImage.vue?vue&type=style&index=0&id=18c011ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c011ce"]])

export default __exports__